import { render, staticRenderFns } from "./u-card-outlined-default.vue?vue&type=template&id=47f6e32c&scoped=true&"
import script from "./u-card-outlined-default.vue?vue&type=script&lang=js&"
export * from "./u-card-outlined-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6e32c",
  null
  
)

export default component.exports